import React, { type PropsWithChildren } from 'react';

type ErrorBoundaryProps = { fallback: React.JSX.Element } & PropsWithChildren;
type ErrorBoundaryState = { hasError: boolean };

// DO NOT USE AS INSPIRATION!
// This is a legacy component, duo that there's as of writting no function alternative.
// See the react docs:
// https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
